import { Box, Dialog, DialogTitle, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '25px',
    backgroundColor: '#FFFFFF',
    minWidth: '680px',
    width: '700px',
  },
  '& .MuiDialog-paperScrollPaper': {
    '&::-webkit-scrollbar': {
      width: 10,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: 10,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    '&::-webkit-scrollbar-track': {
      margin: '60px 0',
    },
  },
}));

export const DialogContainer = styled(Box)(() => ({
  padding: '50px',
}));

export const TopBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  margin: '-20px -30px',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));

export const StyledTitle = styled(DialogTitle)(({ theme }) => ({
  color: '#595959',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '21px',
  fontWeight: '600',
  padding: '0',
  marginBottom: '30px',
  '& span': { color: theme.palette.secondary.main },
}));

export const FormStyled = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '2rem',
}));

export const MultiSelectContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}));

export const InputWrapper = styled(Box)(() => ({
  position: 'relative',
}));

export const MultiSelectLabel = styled('label')(() => ({
  position: 'absolute',
  top: '-9px',
  left: '12px',
  backgroundColor: '#ffffff',
  padding: '0 4px',
  color: 'rgba(0, 0, 0, 0.6)',
  fontSize: '12px',
  fontWeight: '400',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  lineHeight: '1.4375em',
  zIndex: 1,
}));

export const SelectedChipsBox = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
  padding: '10px 14px 8px',
  borderRadius: '16px',
  border: '1px solid rgba(0, 0, 0, 0.23)',
  minHeight: '56px',
  backgroundColor: '#ffffff',
  '&:hover': {
    borderColor: 'rgba(0, 0, 0, 0.87)',
  },
}));

export const OptionsBox = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
  padding: '12px',
  borderRadius: '16px',
  border: '1px solid #e0e0e0',
  backgroundColor: '#ffffff',
}));

export const ChipOption = styled(Box)<{ isSelected?: boolean }>(
  ({ theme, isSelected }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '6px 12px',
    borderRadius: '20px',
    border: `1px solid ${
      isSelected ? theme.palette.secondary.main : '#c4c4c4'
    }`,
    backgroundColor: isSelected
      ? `${theme.palette.secondary.main}15`
      : '#ffffff',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '14px',
    color: '#595959',
    '&:hover': {
      borderColor: theme.palette.secondary.main,
      backgroundColor: `${theme.palette.secondary.main}10`,
    },
    '& span': {
      fontSize: '18px',
      fontWeight: '600',
      color: isSelected
        ? theme.palette.error.main
        : theme.palette.secondary.main,
    },
  })
);
